var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.047,
    height: 17.606,
    viewBox: "0 0 21.047 17.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FFA",
    transform: "translate(1589.822 -3954.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    d: "M122.466,286.425H132.7a.22.22,0,0,0,.172-.083c.131-.161.244-.3.362-.422a.231.231,0,0,0,.059-.19,5.652,5.652,0,0,0-5.492-4.595,5.566,5.566,0,0,0-5.563,5.046.239.239,0,0,0,.059.166.221.221,0,0,0,.166.077Z",
    transform: "translate(-1712.062 3681.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    d: "M156.583,154.154a3.739,3.739,0,1,1-3.739-3.739,3.739,3.739,0,0,1,3.739,3.739",
    transform: "translate(-1737.103 3803.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    d: "M298.88,208.46a3.739,3.739,0,1,0-3.739-3.739A3.742,3.742,0,0,0,298.88,208.46Z",
    transform: "translate(-1873.218 3756.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    "data-name": "Path 4350",
    d: "M268.255,336.758a.208.208,0,0,0,.059.172.216.216,0,0,0,.166.071h10.675a.216.216,0,0,0,.166-.071.228.228,0,0,0,.059-.172,5.562,5.562,0,0,0-1.034-2.722,5.84,5.84,0,0,0-.66-.761,5.589,5.589,0,0,0-9.433,3.483Z",
    transform: "translate(-1848.158 3634.613)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfaIcon);
export default __webpack_public_path__ + "static/media/ffa-icon.60fb961ea24ae863efab9dc457e26d84.svg";
export { ForwardRef as ReactComponent };